import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'; // Importa BehaviorSubject
import { TemplatePortal } from '@angular/cdk/portal';

@Injectable({ providedIn: 'root' })
export class ActionBarPortalService {
  // Inicializa con null. Cualquier nuevo suscriptor recibirá null inicialmente,
  // y luego el portal cuando se llame a setPortal().
  public portal$ = new BehaviorSubject<TemplatePortal<unknown> | null>(null);
  public forceLayoutClass$ = new BehaviorSubject<boolean>(false);
  private registeredPortals: { portal: TemplatePortal<unknown>; forceLayoutClass: boolean }[] = [];

  setPortal(portal: TemplatePortal<unknown> | null, forceLayoutClass: boolean = false): void {
    this.registeredPortals = portal ? [{ portal, forceLayoutClass }] : [];
    this.publishActivePortal();
  }

  registerPortal(portal: TemplatePortal<unknown>, forceLayoutClass: boolean = false): void {
    this.registeredPortals = this.registeredPortals.filter((entry) => entry.portal !== portal);
    this.registeredPortals.push({ portal, forceLayoutClass });
    this.publishActivePortal();
  }

  unregisterPortal(portal: TemplatePortal<unknown>): void {
    const index = this.registeredPortals.findIndex((entry) => entry.portal === portal);
    if (index === -1) {
      return;
    }

    const wasActive = index === this.registeredPortals.length - 1;
    this.registeredPortals.splice(index, 1);
    if (wasActive) {
      this.publishActivePortal();
    }
  }

  /**
   * Forces the application to apply a specific layout class by emitting a value to the `forceLayoutClass$` subject.
   * This method can be used to trigger layout changes programmatically.
   */
  forceLayoutClass(): void {
    const active = this.registeredPortals[this.registeredPortals.length - 1];
    if (active) {
      active.forceLayoutClass = true;
    }
    this.forceLayoutClass$.next(true);
  }

  clearPortal(): void {
    this.registeredPortals = [];
    this.publishActivePortal();
  }

  private publishActivePortal(): void {
    const active = this.registeredPortals[this.registeredPortals.length - 1];
    this.portal$.next(active?.portal ?? null);
    this.forceLayoutClass$.next(active?.forceLayoutClass ?? false);
  }
}
